import React from "react";
import { baseUrl } from "./api/imageService";

interface EvolvingProps {
  lang: string;
}

const videoSources = ["white_6.MP4", "creative.MP4", "pink.mp4", "tulips.MP4"];

export const Evolving: React.FC<EvolvingProps> = ({ lang: _lang }) => {
  return (
    <main className="page-container">
      <section>
        {videoSources.map((src, idx) => (
          <video
            className="experiments-video"
            autoPlay
            muted
            loop
            key={idx}
            data-testid="video-element"
          >
            <source src={`${baseUrl}/creative/${src}`} type="video/mp4" />
          </video>
        ))}
      </section>
    </main>
  );
};
